/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_transactions = {
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelector_transactions">;
    readonly " $refType": "PdpRespSwatchSelector_transactions";
};
export type PdpRespSwatchSelector_transactions$data = PdpRespSwatchSelector_transactions;
export type PdpRespSwatchSelector_transactions$key = {
    readonly " $data"?: PdpRespSwatchSelector_transactions$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_transactions">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_transactions",
  "type": "TransactionConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_transactions",
      "args": null
    }
  ]
};
(node as any).hash = 'bca00afd302d558a31c1e43074357b6b';
export default node;
